export const GENRES = [
  { name: 'Fantasy', slug: 'fantasy', desc: 'Dragons & Magic' },
  { name: 'Mystery', slug: 'mystery', desc: 'Whodunnit?' },
  { name: 'Romance', slug: 'romance', desc: 'Love Stories' },
  { name: 'Sci-Fi', slug: 'sci-fi', desc: 'Space & Future' },
  { name: 'Horror', slug: 'horror', desc: 'Fear & Suspense' },
  { name: 'Thriller', slug: 'thriller', desc: 'Pace & Tension' },
  { name: 'Historical', slug: 'historical', desc: 'Past & Legends' },
  { name: 'Classics', slug: 'classics', desc: 'Timeless Tales' },
  { name: 'City Crime', slug: 'city-crime', desc: 'Everyday streets, plus what the news skips.' },
  { name: 'Social Noir', slug: 'social-noir', desc: 'People, systems, and the damage between them.' },
  { name: 'Online Scams', slug: 'online-scams', desc: 'Messages, links, and “too good to be true” offers.' },
  { name: 'White-Collar', slug: 'white-collar', desc: 'Clean offices, dirty numbers.' },
  { name: 'Digital Shadows', slug: 'digital-shadows', desc: 'Data, leaks, and quiet tracking.' },
  { name: 'Disappeared', slug: 'disappeared', desc: 'Missing people, missing money, missing answers.' },
  { name: 'Short Cases', slug: 'short-cases', desc: 'Quick reads, long aftertaste.' },
];

export const genreOptions = GENRES.map(g => g.name);
